import React, { PureComponent } from "react";
import autoBind from "react-autobind";
import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
//import LinearGradient from "react-native-linear-gradient";
import { Button } from "react-bootstrap";
import _ from "lodash";
import * as playerActions from "../../actions/playerActions";

import { evalItemText } from "../../utils/runtimeApiUtils";

import { getRealName } from "../../utils/utils";


const removeMd = require("remove-markdown");

class Breadcrumb extends PureComponent {
	constructor(props) {
		super(props);
		autoBind(this);
	}

	handleShowView(expandedView, searchFocus=false) {
		this.props.dispatch(playerActions.setExpandedBreadcrumbView, expandedView, searchFocus);
	}

	handleToggleBirdseyeView() {
		this.props.dispatch(playerActions.toggleSectionsMenuVisible);
	}

	renderBreadcrumbComponent(entity, labelProp, selectedValue) {
		let result = [];
		const { expandedView } = this.props;
		const { type, guid, insertedByNormalization } = entity;
		if (!insertedByNormalization) {
			const isItem = type && type.startsWith("item");

			const label = isItem ? evalItemText(entity,entity[labelProp]) : entity[labelProp];

			let title = entity.navTitle ? entity.navTitle : getRealName(removeMd(label));
			const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
			const { breadcrumb: breadcrumbTheme } = theme;

			let auxStyles = {};
			if (!isItem) {
				auxStyles.maxWidth = "30%";

				if (window.innerWidth < 500) {
					auxStyles.maxWidth = "25%";
					auxStyles.paddingLeft = 1;
					auxStyles.paddingRight = 1;
				}

			} else {
				auxStyles.overflow = "hidden";
			}

			let styles = _.assign({}, breadcrumbTheme.itemStyles, auxStyles);
			if (!isItem) {
				styles = _.omit(styles, ["flex"]);
			}
			styles = _.omit(styles, ["height"]);
			let chevronColor = "#999999";

			let overflowStyles = breadcrumbTheme.itemOverflowStyles;
			if (breadcrumbTheme.textOverFlowGradient) {
				overflowStyles = _.assign({}, overflowStyles, { background: `linear-gradient(to right, ${breadcrumbTheme.textOverFlowGradient.startColor}, ${breadcrumbTheme.textOverFlowGradient.endColor})` });
			}
			if (expandedView === selectedValue) {
				// styles.backgroundColor = "#888888";
				chevronColor = "white";
				overflowStyles = _.assign({}, overflowStyles, breadcrumbTheme.itemOverflowSelectedStyles);
			}

			result.push(<div style={styles} key={`bc-${selectedValue}-${guid}`} onClick={() => { this.handleShowView(selectedValue); }}>
				{title}
				<div style={overflowStyles} />
			</div>);
			if (!isItem) {
				let _chevronIconStyles = _.assign({}, breadcrumbTheme.chevronIconStyles, {
					color: chevronColor
				});
				result.push(<div key={`bc-${selectedValue}-sep-${guid}`} style={breadcrumbTheme.chevron}><FontAwesomeIcon icon={breadcrumbTheme.chevronIcon} style={_chevronIconStyles} /></div>);
			}

		}
		
		return result;
	}

	handleHideView() {
		this.props.dispatch(playerActions.setExpandedBreadcrumbView, null);
	}

	render() {
		const { navStack, expandedView } = this.props;
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		const { breadcrumb: breadcrumbTheme } = theme;
		const { historyButton } = breadcrumbTheme;
		const currentItemHierarchy = playerActions.getSelectionHierarchy();

		let goBackButton;
		if (navStack.length > 0) {
			goBackButton = <div style={historyButton.container}>
				<div style={historyButton.buttons.goBack} onClick={() => { this.props.dispatch(playerActions.goBackFromLink); }}>
					<FontAwesomeIcon icon={historyButton.buttons.goBackIcon} style={historyButton.buttons.goBackIconStyles}/>
				</div>
				<div style={historyButton.buttonSeparator}/>
				<div style={historyButton.buttons.toggleHistory} onClick={() => { this.handleShowView("navStack"); }}>
					<FontAwesomeIcon icon={historyButton.buttons.toggleHistoryIcon} style={historyButton.buttons.toggleHistoryIconStyles} />
				</div>
			</div>;
		}

		// console.log("Render breadcrumb", navStack);
		const comps = [];
		navStack.forEach((nav, i) => {
			let reference = `${nav.item.listIndex}/${nav.item.sectionIndex}/${nav.item.itemIndex}`;
			if (nav.navTitle) {
				reference = nav.navTitle;
			}
			comps.push(<div key={`nav-${i}`} onClick={() => { this.props.dispatch(playerActions.goBackFromLink, false, i); }}>
				<span style={{ color: "white", textDecorationLine: "underline" }}>{nav.activityName} ({reference})</span>
			</div>);

			if ((i + 1) < navStack.length) {
				comps.push(<div key={`sep-${i}`} style={breadcrumbTheme.chevron}><FontAwesomeIcon icon={breadcrumbTheme.chevronIcon} style={breadcrumbTheme.chevronIconStyles}/></div>);
			}
		});

		let breadcrumb = [];
		const { list, section, item } = currentItemHierarchy;
		if (list) {
			// const needsTruncated = (!list.navTitle || _.isEmpty(list.navTitle)) && list.name.length > 24;
			// const title = list.navTitle ? list.navTitle : _.truncate(list.name, {
			// 	length: 24,
			// 	omission: ""
			// });
			// let gradientComponent = null;
			// if (needsTruncated) {
			// 	gradientComponent = <LinearGradient key="bc-list-gradient" style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 20 }} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={['rgba(68,68,68,0)', 'rgba(68,68,68,.9)']} />
			// }
			// const styles = { position: "relative", height: "100%" };
			// if (expandedView === "lists") {
			// 	styles.backgroundColor = "#888888";
			// }
			// breadcrumb.push(<div style={styles} key={"bc-list"} onClick={(e) => {  }}>
			// 	<Text style={{ color: "white" }}>{title}</Text>
			// 	{gradientComponent}
			// </div>);
			// breadcrumb.push(<div key={"bc-list-sep"} style={{ width: 20, height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}><FontAwesomeIcon icon="chevron-right" style={{ color: "#999999" }} /></div>);
			breadcrumb = _.concat(breadcrumb, this.renderBreadcrumbComponent(list, "name", "tree"));
		}
		if (section) {
			// const needsTruncated = (!section.navTitle || _.isEmpty(section.navTitle)) && section.name.length > 24;
			// const title = section.navTitle ? section.navTitle : _.truncate(section.name, {
			// 	length: 24,
			// 	omission: ""
			// });
			// let gradientComponent = null;
			// if (needsTruncated) {
			// 	gradientComponent = <LinearGradient key="bc-section-gradient" style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 20 }} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={['rgba(68,68,68,0)', 'rgba(68,68,68,.9)']} />
			// }
			// const styles = { position: "relative", height: "100%" };
			// if (expandedView === "sections") {
			// 	styles.backgroundColor = "#888888";
			// }
			// breadcrumb.push(<div style={styles} key={`bc-section`} onClick={(e) => {  }}>
			// 	<Text style={{ color: "white" }}>{title}</Text>
			// 	{gradientComponent}
			// </div>);
			// breadcrumb.push(<div key={"bc-section-sep"} style={{ width: 20, height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}><FontAwesomeIcon icon="chevron-right" style={{ color: "#999999" }} /></div>);
			breadcrumb = _.concat(breadcrumb, this.renderBreadcrumbComponent(section, "name", "tree"));
		}
		if (item) {

			// const needsTruncated = (!item.navTitle || _.isEmpty(item.navTitle)) && item.label1.length > 24;
			// const title = item.navTitle ? item.navTitle : _.truncate(item.label1, {
			// 	length: 24,
			// 	omission: ""
			// });
			// let gradientComponent = null;
			// if (needsTruncated) {
			// 	gradientComponent = <LinearGradient key="bc-item-gradient" style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 20 }} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={['rgba(68,68,68,0)', 'rgba(68,68,68,.9)']}/>
			// }
			// const styles = { position: "relative", height:"100%" };
			// if (expandedView === "items") {
			// 	styles.backgroundColor = "#888888";
			// }
			// breadcrumb.push(<div style={styles} key={`bc-item`} onClick={(e) => { this.handleShowView("items") }}>
			// 	<Text style={{ color: "white" }}>{title}</Text>
			// 	{gradientComponent}
			// </div>);
			breadcrumb = _.concat(breadcrumb, this.renderBreadcrumbComponent(item, "label1", "tree", true));
		}

		const _targetBreadcrumbBarStyles = _.assign({}, breadcrumbTheme.breadcrumbBar, expandedView ? breadcrumbTheme.breadcrumbBarExpanded : {});
		const isSmallScreen = window.innerWidth < 500;
		if (isSmallScreen) {
			_targetBreadcrumbBarStyles.paddingLeft = 5;
			_targetBreadcrumbBarStyles.paddingRight = 5;
		}
		return (<div id="jr-breadcrumb" key="breadcrumb-bar" style={breadcrumbTheme.container}>
					{goBackButton}
					<div
						ref={ref => this.scrollView = ref}	
						// onContentSizeChange={(contentWidth, contentHeight) => {
						// 	this.scrollView.scrollToEnd({ animated: true });
						// }}
						// horizontal
				style={_targetBreadcrumbBarStyles}>
					{breadcrumb}
				{!expandedView && <Button id="jr-breadcrumb-search" bsSize={isSmallScreen?"sm":"medium"} onClick={() => { this.handleShowView("tree", true); }}><FontAwesomeIcon icon="search" /></Button>}
				{!expandedView && <Button id="jr-breadcrumb-birdseye" bsSize={isSmallScreen ? "sm" : "medium"} style={{ marginLeft: isSmallScreen ? "2px":"10px"}} onClick={() => { this.handleToggleBirdseyeView(); }}><FontAwesomeIcon icon={this.props.sectionsMenuVisible?"list":"eye"} /></Button>}
					</div>
					{/* <div style={{ width: 24, height: 24, marginTop: 3, marginRight: 3, backgroundColor: "red", display: "flex", justifyContent: "center", alignItems: "center", flex: 0 }} onClick={(e) => { this.props.dispatch(Actions.goBackDismiss); }}>
						<FontAwesomeIcon icon="times" style={{ fontWeight: "bold", color: "white" }} />
					</div> */}
			{expandedView && <div style={breadcrumbTheme.dialog.closeButton} onClick={() => { this.handleHideView(); }}><FontAwesomeIcon icon="times" style={breadcrumbTheme.dialog.closeButtonIconStyles} /></div>}
				</div>);
		}
	}


	
Breadcrumb.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	sectionsMenuVisible: ["appState","sectionsMenuVisible"],
	navStack: ["player", "navStack"],
	expandedView: ["player", "breadcrumb", "expandedView"],
	selectedItem: ["activity", "selected"]
}, Breadcrumb);